import React from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import PageLoader from './ui/PageLoader';
import { ownerProfilePath } from '../navigation/browseDestinations';

/**
 * `/garage` is no longer a destination. Owner vehicles live on the public profile.
 */
const GarageRedirect: React.FC = () => {
  const { user, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const [params] = useSearchParams();

  if (isLoading) {
    return <PageLoader message="Opening your profile…" />;
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        state={{ from: `${location.pathname}${location.search}` }}
        replace
      />
    );
  }

  const addVehicle =
    params.get('add') === '1' ||
    Boolean((location.state as { openAddVehicle?: boolean } | null)?.openAddVehicle);

  return <Navigate to={ownerProfilePath(user?.username, { addVehicle })} replace />;
};

export default GarageRedirect;
